<div class="auth-container">
  <div class="header">
    <div class="logo">
      <img
        src="assets/vite-marketplace-logo-dark.svg"
        [alt]="translationService.getBrandLogoText()"
        height="50px"
      />
    </div>
    <h2>{{ translationService.getLoginText() }}</h2>
  </div>
  @if (!isMfaRequired) {
    <form [formGroup]="loginForm">
      <div class="form-groups margin-top-20">
        <div class="form-group margin-top-10">
          <mat-form-field appearance="outline">
            <mat-label>{{
              translationService.getEmailAddressText()
            }}</mat-label>
            <input matInput type="email" name="email" formControlName="email" />
          </mat-form-field>
        </div>
        <div class="form-group margin-top-10">
          <mat-form-field appearance="outline">
            <mat-label>{{ translationService.getPasswordText() }}</mat-label>
            <input
              matInput
              type="password"
              name="password"
              formControlName="password"
            />
          </mat-form-field>
        </div>
      </div>
      <div class="actions margin-top-10">
        <button
          mat-raised-button
          extended
          color="primary"
          class="action-item"
          (click)="login()"
        >
          <mat-icon>login</mat-icon>
          {{ translationService.getLoginText() }}
        </button>
        <a [routerLink]="['/auth/reset-password']">{{
          translationService.getForgotPasswordText()
        }}</a>
      </div>
    </form>
  } @else {
    <app-mfa
      [userId]="mfaUserId"
      (mfaVerified)="handleLoginSuccess($event)"
    ></app-mfa>
  }
</div>
